import { render, staticRenderFns } from "./detailCarInfo.vue?vue&type=template&id=81485340&scoped=true"
import script from "./detailCarInfo.vue?vue&type=script&lang=js"
export * from "./detailCarInfo.vue?vue&type=script&lang=js"
import style0 from "./detailCarInfo.vue?vue&type=style&index=0&id=81485340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81485340",
  null
  
)

export default component.exports